module.exports = __webpack_public_path__ + "img/cl+cl-r.df5c9d6b.jpg";